export enum ColorShades {
    'CS100' = 100,
    'CS200' = 200,
    'CS300' = 300,
    'CS500' = 500,
    'CS700' = 700,
    'CS900' = 900,
}
